module.exports = __webpack_public_path__ + "media/src/images/team-bcb6c61f55af2b511c3e16107e21b980.png";